module.exports = __webpack_public_path__ + "static/img/y5.cb29a15d.svg";